export default __webpack_public_path__ + "static/media/bg.f21841c3.png";